module.exports = __webpack_public_path__ + "img/nft4.8b25c5db.jpg";